import { EIGHT_HOURS, ESeverity, FOUR_HOURS } from '#shared';

export const getTimeSeverityFromMin = (minutes: number) => {
  switch (true) {
    case minutes < FOUR_HOURS:
      return ESeverity.CRITICAL;
    case minutes < EIGHT_HOURS:
      return ESeverity.MAJOR;
    default:
      return ESeverity.LOW;
  }
};
